import assetFragment from '@lib/fragments/asset-fragment';
import gql from 'graphql-tag';

const imageSliderSectionFragment = gql`
  fragment imageSliderSectionFields on ImageSliderSection {
    images {
      __typename
      ...assetFields
      url(width: 800, height: 500, format: "webp")
    }
    backgroundColor: background_color {
      color
    }
  }
  ${assetFragment}
`;

export default imageSliderSectionFragment;
